// walletconnect-v2.service.ts
import { Injectable } from '@angular/core';
import EthereumProvider from '@walletconnect/ethereum-provider';
import { ethers } from 'ethers';
import { Subject } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class WalletConnectV2Service {
  private wc?: any;                        // EIP-1193 provider WalletConnect v2
  private ethersProvider?: ethers.BrowserProvider;
  public address?: string;
  public chainId?: number;
   public log$ = new Subject<string>();
  private log = (m: string) => { console.debug('[WC2]', m); this.log$.next(m); };
  get isConnected() { return !!this.address; }

  public wcUri$ = new Subject<string | null>();
  public lastDisplayUri: string | null = null;


  // WalletConnectV2Service
// walletconnect-v2.service.ts
async init(projectId: string) {
  if (this.wc) return;
  this.log(`init(projectId=${projectId.slice(0,6)}...)`);

  this.wc =await EthereumProvider.init({
    projectId,
    metadata: {
      name: "SwapX",
      description: "Swap & Bridge app",
      url: "https://swaptokens-zeta.vercel.app", // ← IMPORTANT: doit matcher ton origin
      icons: ["https://swaptokens-zeta.vercel.app/assets/icon-512.png"],
    },
    // Recommandé: utiliser optionalChains plutôt que chains (CAIP-25)
    optionalChains: [1, 137, 10, 42161, 56], // ETH, Polygon, Optimism, Arbitrum, BSC
    // Facultatif mais utile: RPC map explicite
    rpcMap: {
      1: "https://eth-mainnet.g.alchemy.com/v2/gCvph7eowzBP0e2uUN177AELQnht-CXN",
      137: "https://polygon-mainnet.g.alchemy.com/v2/gCvph7eowzBP0e2uUN177AELQnht-CXN",
      10: "https://rpc.ankr.com/optimism/3daf9fb1a12a913bd97e56c90e6d15db5dd60f66b4d67b45736ba3f8f3e604f2",
      42161: "https://arb-mainnet.g.alchemy.com/v2/id2ETOtmTy1BpEYYsngoBNiBwnx2bGeD",
      56: "https://bnb-mainnet.g.alchemy.com/v2/gCvph7eowzBP0e2uUN177AELQnht-CXN",
    },
    showQrModal: true, // (la doc indique AppKit de préférence, mais accepté ici)
  });

  this.log('WC2 provider created (CAIP-25)');

  // ✅ capture du display_uri WalletConnect v2
  this.wc.on?.('display_uri', (uri: string) => {
    const raw = uri || '';
    this.lastDisplayUri = raw;
    this.wcUri$.next(raw);
    this.log(`display_uri (len=${raw.length})`);
  });

}




public isReady(): boolean {
  return !!this.wc;
}
  private async bindEthers() {
    const accounts: string[] = await this.wc.request({ method: 'eth_accounts' });
    const chainIdHex: string = await this.wc.request({ method: 'eth_chainId' });
    this.address = accounts?.[0];
    this.chainId = parseInt(chainIdHex, 16);
    this.ethersProvider = new ethers.BrowserProvider(this.wc as any);
    this.log(`bindEthers -> ${this.address} on chain ${this.chainId}`);
  }

  async connect() {
    this.log('connect(): opening modal…');
    await this.wc.connect(); // IMPORTANT en v2
    this.log('connect(): paired, requesting accounts…');
    const accs: string[] = await this.wc.request({ method: 'eth_accounts' });
    await this.bindEthers();
    this.log(`connect(): ok -> ${accs?.[0]}`);
    return { address: this.address!, chainId: this.chainId!, provider: this.ethersProvider! };
  }

  async switchChain(targetChainId: number) {
    const hex = '0x' + targetChainId.toString(16);
    try {
      await this.wc.request({ method: 'wallet_switchEthereumChain', params: [{ chainId: hex }] });
    } catch (e: any) {
      // option: add chain if missing
      console.warn('switchChain error', e);
      throw e;
    }
  }

  async disconnect() {
    try { await this.wc.disconnect(); } catch {}
    this.reset();
  }

  getProviderSafe(): ethers.BrowserProvider | null {
    return this.ethersProvider ?? null;
  }

  private reset() {
    this.address = undefined;
    this.chainId = undefined;
    this.ethersProvider = undefined;
    this.lastDisplayUri = null;
    this.wcUri$.next(null);
  }

}
